import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aad41896"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "new-detail"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "path"
}, "动态新闻 / 新闻内容", -1));
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "source"
};
const _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString($data.detail.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString($data.detail.source), 1), _createElementVNode("div", null, _toDisplayString($data.detail.publishTime.slice(0, 10)), 1)]), _createElementVNode("div", {
    innerHTML: $data.detail.content,
    class: "inner"
  }, null, 8, _hoisted_6)]), _createVNode(_component_router_link, {
    class: "home",
    to: "/home"
  })]);
}